import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import QRPage from "./container/qr/qr";
import PrivateRoute from "./components/PrivateRoute/PrivateRoute";
import Login from "./container/Login/Login";



const App: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="login" element={<Login/>}/>
        <Route path="/" element={<PrivateRoute />}>
          <Route path="/" element={<QRPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default App;
